import React, { useState, useEffect } from 'react';
import cn from "classnames";
import stylesCommon from "../../common.module.scss"
import CustomButton from '../../../custom/custom-button/CustomButton';
import CustomInput from '../../../custom/custom-input/CustomInput';
import axios from 'axios';
import { User } from "../../../../services";
import { useTranslation } from 'react-i18next';

const BIN_LENGTH = 12;

const validateUserName = (userName) => {
  const namePattern = /^[A-Za-zА-Яа-я]/;
  return namePattern.test(userName);
};

const SurveyUserRegistrationFirst = ({ updateStep, setData, data }) => {
  const { t } = useTranslation();
  const [bin, setBin] = useState(data?.bin || '');
  const [companyName, setCompanyName] = useState(data?.companyName || '');

  const [errorTitleBin, setErrorTitleBin] = useState();
  const [errorTitleNameCompany, setErrorTitleNameCompany] = useState();

  const nextStep = async () => {
    setErrorTitleBin(null);
    setErrorTitleNameCompany(null);

    if (bin.length !== BIN_LENGTH) {
      setErrorTitleBin(t('registrationSurveyUserFirst.validation.binLengthError', { length: BIN_LENGTH }));
      return;
    }
    if (!validateUserName(companyName)) {
      setErrorTitleNameCompany(t('registrationSurveyUserFirst.validation.orgNameRequired'));
      return;
    }

    const isBinValid = await checkBin(bin);

    if (!isBinValid) {
      setErrorTitleBin(t('registrationSurveyUserFirst.validation.binExists'));
      return;
    }

    setData({
      ...data,
      bin: bin,
      companyName: companyName,
    });

    updateStep(3);
  };

  const checkBin = async (bin) => {
    try {
      const response = await User.checkBin(bin);
      if (!response.data.isExists) {
        return true
      } else if (response.data.isExists) {
        return false
      }
    } catch (error) {
      console.error('Error checking BIN:', error);
      return false;
    }
  };

  useEffect(() => {
    if (data.setCompanyName) setUserName(data.companyName);
  }, [data]);

  return (
    <div className={stylesCommon.fullWidth}>
      <div className={stylesCommon.form}>
        <CustomInput
          placeholder="123456789012"
          labelText={t('registrationSurveyUserFirst.label.binIin')} // Use specific label
          inputType="text"
          onChangeValue={setBin}
          value={bin}
          errorText={errorTitleBin}
          maxLength={BIN_LENGTH}
          isBin
        />
        <CustomInput
          placeholder={t('registrationSurveyUserFirst.placeholder.orgName')}
          labelText={t('registrationSurveyUserFirst.label.orgName')}
          inputType="text"
          onChangeValue={setCompanyName}
          value={companyName}
          errorText={errorTitleNameCompany}
        />
      </div>
      <div className={stylesCommon.btns}>
        <CustomButton isFall text={t('registrationSurveyUserFirst.button.continue')} onClick={nextStep} />
      </div>
    </div>
  );
};

export default SurveyUserRegistrationFirst;
